import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LiveFeedChannel } from '../../ActionCable/Channels';

/**
 * This react hook is responsible for displaying new enrouted order as an popup
 * @returns
 */
const useLiveFeed = () => {
  const [hasRecieved, setHasRecieved] = useState(false);
  const [enroutedPracticeId, setEnroutedPracticeId] = useState(0);
  const user = useSelector((state) => state.userReducer.user);
  useEffect(() => {
    LiveFeedChannel(user.id).received = (data) => {
      if (Object.keys(data.data).length > 0) {
        setEnroutedPracticeId(data.data.practice_id);
        setHasRecieved(true);
      }
    };
  }, []);

  return [hasRecieved, setHasRecieved, enroutedPracticeId];
};
export default useLiveFeed;
